<template>
    <div>
        <h3 style="color: #E16531">欢迎您使用智慧停车商家管理系统</h3>
    </div>
</template>
<script>
export default {
  created () {
    this.getMerchantInfo()// 获取商户信息
  },

  data () {
    return {

    }
  },

  methods: {
    // 获取商户信息放入session
    getMerchantInfo () {
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') { // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      this.$http.get(
        'queryMerchantInfoByToken',
        {
          headers: { token: token }
        }
      ).then(result => {
        const res = result.data
        if (res.code === '0') {
          // 将商户返回信息放入sessionStorage
          window.sessionStorage.setItem('merchantId', res.data.merchantId)
          window.sessionStorage.setItem(
            'couponMoneyList',
            res.data.couponMoneyList
          )
          window.sessionStorage.setItem(
            'roadValidScope',
            res.data.roadValidScope
          )
          window.sessionStorage.setItem(
            'thirdValidScope',
            res.data.thirdValidScope
          )
        } else {
          this.$message.error('查询商户信息异常，请联系管理员')
        }
      }).catch(res => {
        this.$message.error('程序异常，请联系管理员')
      })
    }
  }
}
</script>
